import React from 'react'
import { twMerge } from 'tailwind-merge'
import { Menu } from '../../../Menu'
import { Search } from '../../Input'

type Props = {
  isVisible: boolean
  triggerRef?: React.MutableRefObject<HTMLElement | null | undefined>
  search?: boolean
  setVisible: any
  setSearchTerm: any
  className?: string
  children?: React.ReactNode
}

export const OptionsMenu = ({ isVisible, setVisible, ...props }: Props) => {
  return (
    <Menu
      data-testid='options-menu'
      triggerRef={props.triggerRef}
      isOpen={isVisible}
      menuWidth='match-trigger'
      sideOffset={0}
      onClose={() => setVisible(false)}
      className={twMerge(
        'focus-within:border-blue-300 dark:border-none p-1 max-h-[400px] overflow-y-scroll dark:border-gray-700 dark:bg-base-800',
        props.className,
      )}>
      {props.search && (
        <div className='mb-3 border-b border-gray-500'>
          <Search debounce onSearch={props.setSearchTerm} autoFocus />
        </div>
      )}
      {props.children}
    </Menu>
  )
}
